export const partner = [{
        id: 1,
        name: "Alfamart",
        file_name: "alfamart.png",
    },
    {
        id: 2,
        name: "Alfamidi",
        file_name: "alfamidi.png",
    },
    {
        id: 3,
        name: "Atm Bersama",
        file_name: "atmbersama.png",
    },
    {
        id: 4,
        name: "BakmiGM",
        file_name: "bakmiGM.png",
    },
    {
        id: 5,
        name: "Bank BCA",
        file_name: "bca.png",
    },
    {
        id: 6,
        name: "Bank BNI",
        file_name: "bni.png",
    },
    {
        id: 7,
        name: "BPJS",
        file_name: "bpjs.png",
    },
    {
        id: 8,
        name: "Bank BTPN",
        file_name: "btpn.png",
    },
    {
        id: 9,
        name: "Bukalapak",
        file_name: "bukalapak.png",
    },
    {
        id: 10,
        name: "Dan Dan",
        file_name: "dandan.png",
    },
    {
        id: 11,
        name: "Hoka Bento",
        file_name: "hokben.png",
    },
    {
        id: 12,
        name: "KFC",
        file_name: "kfc.png",
    },
    {
        id: 13,
        name: "Kopi Kenangan",
        file_name: "kopikenangan.png",
    },
    {
        id: 14,
        name: "Mandiri",
        file_name: "mandiri.png",
    },
    {
        id: 15,
        name: "Maybank",
        file_name: "maybank.png",
    },
    {
        id: 16,
        name: "Ramayanan",
        file_name: "ramayana.png",
    },
    {
        id: 17,
        name: "TIX ID",
        file_name: "tixid.png",
    },
    {
        id: 18,
        name: "Vidio",
        file_name: "vidio.png",
    },
];